export const EvaluationSkillCatalog = {
    path: '/evaluation_skill_catalog',
    name: 'evaluation_skill_catalog',
    component: () => import('@/views/DataSelect/DataSelectPage.vue'),
    props: {externType: 'EVALUATION_SKILL_CATALOG'},
    children: [
        {
            path: '/evaluation_skill_catalog/add',
            name: 'evaluation_skill_catalog.add',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {addAction: true, externType: 'EVALUATION_SKILL_CATALOG'}
        },
        {
            path: '/evaluation_skill_catalog/edit/:id',
            name: 'evaluation_skill_catalog.edit',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {updateAction: true, externType: 'EVALUATION_SKILL_CATALOG'}
        },
        {
            path: '/evaluation_skill_catalog/delete/:id',
            name: 'evaluation_skill_catalog.delete',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {deleteAction: true, externType: 'EVALUATION_SKILL_CATALOG'}
        },
        {
            path: '/evaluation_skill_catalog/view/:id',
            name: 'evaluation_skill_catalog.view',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {viewAction: true, externType: 'EVALUATION_SKILL_CATALOG'}
        },
    ]
}